import { RefObject, ReactElement } from 'react';
import { Box, Container, Flex, UnorderedList } from '@chakra-ui/react';
import { FieldErrors } from 'react-hook-form';

import Heading from 'components/atoms/heading';
import { ListItem } from 'components/atoms/listItem';
import ManWithGlass from 'components/atoms/images/manWithGlass';
import PurpleCircle from 'components/atoms/images/purpleCircle';
import FormFirstStep, {
  FormFirstStepProps,
} from 'components/organisms/candidates/registrationForm/firstStep';
import FormSecondStep, {
  FormSecondStepProps,
} from 'components/organisms/candidates/registrationForm/secondStep';
import { IconType } from 'lib/@types';

export type InputsSecondStep = {
  fullName: string;
  password: string;
  repeatPassword: string;
};

export interface RegistrationFormProps
  extends FormFirstStepProps,
    FormSecondStepProps {
  formTitle: string;
  formList: Array<{
    icon: IconType;
    text: string;
  }>;
  formStep: number;
  formErrors: FieldErrors;
  formRef?: RefObject<HTMLDivElement>;
}

const RegistrationForm = ({
  formTitle,
  formList,
  formStep,
  changeFormStep,
  submitFirstStep,
  submitSecondStep,
  formErrors,
  formRef,
}: RegistrationFormProps): ReactElement => (
  <Box
    bgColor='background.900'
    w='100%'
    position='relative'
    overflow='hidden'
    px={[4, 4, 0, 0]}
    id='form'
  >
    <Container maxW='container.xl' ref={formRef}>
      <Flex justify='start'>
        <Box
          w='670px'
          paddingTop={[28, 28, 60, 60]}
          paddingBottom='40'
          zIndex='3'
        >
          <Heading format='h1'>{formTitle}</Heading>

          <UnorderedList listStyleType='none' marginInlineStart='0' my='8'>
            {formList.map((listItem) => (
              <ListItem
                key={listItem.text}
                icon={listItem.icon}
                color='text.200'
              >
                {listItem.text}
              </ListItem>
            ))}
          </UnorderedList>

          {formStep === 1 ? (
            <FormFirstStep
              formErrors={formErrors}
              submitFirstStep={submitFirstStep}
            />
          ) : (
            <FormSecondStep
              submitSecondStep={submitSecondStep}
              changeFormStep={changeFormStep}
            />
          )}
        </Box>

        <ManWithGlass
          w={{ xl: 650, md: 400, sm: 0 }}
          h={{ xl: 650, md: 400, sm: 0 }}
          layout='fill'
          pos='absolute'
          right={0}
          bottom={0}
          zIndex={2}
        />

        <PurpleCircle
          w={{ xl: 250, md: 150, sm: 0 }}
          h={{ xl: 250, md: 150, sm: 0 }}
          layout='fill'
          pos='absolute'
          right={0}
          bottom='-8px'
          zIndex={1}
        />
      </Flex>
    </Container>
  </Box>
);

export default RegistrationForm;
